import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Smuzi = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/' name='Смузi та мiлкшейки'/>
            <main className={s.main}>
                <p>Смузі (300мл.)</p>
                <Product name='До сніданку' price='70 грн.' info1='молоко, банан, шоколадні пластівці, цукровий сироп'/>
                <Product name='Із заморожених ягід' price='80 грн.' info1='йогурт, банан, малина, чорниця, молоко, ванільний сироп'/>
                <Product name='Бананово-малиновий' price='70 грн.' info1='молоко, банан, малина'/>
                <Product name='З консервованим ананасом та бананом' price='80 грн.' info1='ананас, банан, апельсиновий сік, лід'/>
                <Product name='Яблучно-банановий' price='70 грн.' info1='молоко, яблуко, йогурт, банан, цукровий сироп'/>
                <Product name='З бананом, ківі та малиною' price='80 грн.' info1="ананасовий сік, банан, ківі, малина, цукровий сироп, м'ята, лід"/>
                <Product name='Із заморожених ягід з шоколадними пластівцями та бананом' price='80 грн.' info1='яблучний сік, банан, малина, вишня, чорниця, шоколадні пластівці, цукровий сироп'/>
                <Product name='Кокосово-банановий' price='70 грн.' info1='молоко, банан, кокосовий сироп, кориця'/>
                <Product name='Тутті-Фрутті' price='70 грн.' info1='молоко, банан, апельсин, вишня, кокосовий сироп, цукровий сироп'/>
                <Product name='З зефіром, малиною та бананом' price='85 грн.' info1='молоко, банан, зефір, малина'/>
                <Product name='Яблучно-апельсиновий' price='70 грн.' info1='яблуко, банан, апельсиновий сік'/>
                <p>Мілкшейки (400мл.)</p>
                <Product name='Молочно-банановий' price='90 грн.' info1='молоко, банан, морозиво, какао, ванільний сироп, цукровий сироп'/>
                <Product name='Ягідний' price='110 грн.' info1='молоко, морозиво, малина, чорниця, вишня, цукровий сироп'/>
                <Product name='Молочний' price='90 грн.' info1='молоко, морозиво, банан, цукровий сироп, ванільний сироп'/>
                <Product name='Піна колада' price='110 грн.' info1='ананасовий сік, морозиво, кокосовий сироп, вершки'/>
                <Product name='Снікерс' price='140 грн.' info1='молоко, морозиво, банан, цукерка "Снікерс", шоколадний сироп, арахіс, вершки, шоколадний топінг'/>
                <Product name='Малинова ніжність' price='90 грн.' info1='молоко, морозиво, малина, цукровий сироп'/>
                <Product name='Орео' price='130 грн.' info1='молоко, морозиво, печиво "Орео", вершки, шоколадний топінг'/>
                <Product name='З колою' price='90 грн.' info1='кока-кола, морозиво, вишневий сік, лаймовий сироп, молоко'/>
                <Product name='Шоколадно-банановий' price='100 грн.' info1='молоко, банан, молочний шоколад, морозиво, шоколадний сироп'/>
            </main>
        </div>
    )
}

export default Smuzi;